import {Component, computed, inject, input, output} from '@angular/core';
import {Button} from 'primeng/button';
import {Tooltip} from 'primeng/tooltip';
import {TranslocoService} from '@jsverse/transloco';
import {ConfirmStepLeaveDirective} from './confirm-step-leave.directive';
import {ProjectStepStateService} from '../../pages/customer/project-sequence/project-step-state.service';
import {UserContractService} from '../services/user-contract.service';

@Component({
  selector: 'app-project-step-save-button',
  imports: [Button, Tooltip, ConfirmStepLeaveDirective],
  templateUrl: './project-step-save-button.component.html',
})
export class ProjectStepSaveButtonComponent {
  private readonly translocoService = inject(TranslocoService);
  private readonly stepStateService = inject(ProjectStepStateService);
  private readonly userContractService = inject(UserContractService);

  readonly label = input<string>();
  readonly loading = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly styleClass = input<string>('px-8! text-sm! uppercase');

  readonly clicked = output<void>();

  protected readonly isStepLocked = computed(() => {
    const activeStep = this.stepStateService.activeStep();
    if (!activeStep) {
      return false;
    }

    return this.stepStateService.isStepLocked(activeStep.chapterId, activeStep.stepId);
  });

  protected readonly hasNoActiveContract = computed(() => {
    const hasContract = this.userContractService.hasActiveContract();
    return hasContract === false;
  });

  protected readonly isDisabled = computed(() => {
    return this.disabled() || this.isStepLocked() || this.hasNoActiveContract();
  });

  protected readonly tooltip = computed(() => {
    if (this.isStepLocked()) {
      return this.translocoService.translate('project.steps.stepLocked');
    }
    if (this.hasNoActiveContract()) {
      return this.translocoService.translate('project.steps.noActiveContract');
    }
    return undefined;
  });

  protected readonly buttonLabel = computed(() => {
    if (this.loading()) {
      return this.translocoService.translate('common.saving');
    }
    return this.label() ?? this.translocoService.translate('common.save');
  });

  handleClick(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!this.isDisabled()) {
      this.clicked.emit();
    }
  }
}
